import React from "react";
import { Form, Input, FormInstance, Spin } from "antd";
import { CustomModal } from "../../utils/StyledComponents";
import { LanguageSelectItem } from "../../custom-components/form/fliter";
import { useOutletContext } from "react-router-dom";

interface Props {
	isOpen: boolean;
	saveEditData: () => void;
	form: FormInstance; 
	isLoading: boolean;
	handleCancel: () => void;
	editId?: string;
}

const AlternateTitleForm: React.FC<Props> = ({
	isOpen,
	saveEditData,
	form,
	isLoading,
	handleCancel
}) => {
	const { languagesList }: any = useOutletContext();
	return (
		<CustomModal
			centered
			width={600}
			open={isOpen}
			maskClosable={false}
			title={"Add Alternate Title"}
			okText={"Save"}
			onOk={saveEditData}
			onCancel={handleCancel}
			okButtonProps={{ disabled: isLoading }}
			cancelButtonProps={{ disabled: isLoading }}
		>
			<Spin spinning={isLoading}>
				<Form form={form} requiredMark={false} layout="vertical" initialValues={{alternate_title_language: "English"}}>
					<Form.Item label="Ref ID" name="alternate_title_ref_id">
						<Input placeholder="Ref ID" />
					</Form.Item>
					<Form.Item
						label="Alternate Title"
						name="alternate_title"
						rules={[{ required: true, message: "This is required field" }]}
					>
						<Input placeholder="Alternate Title" />
					</Form.Item>
					<LanguageSelectItem
						label="Language"
						languages={languagesList}
						placeholder="Alternate title language"
						name="alternate_title_language"
					/>
				</Form>
			</Spin>
		</CustomModal>
	);
};

export default AlternateTitleForm;
